<template>
<div>
    <b-overlay :show="showoverlay" rounded="sm" class='trustee-overlay'>
        <div class="clearfix company-form-container company-form-container-warapper">
            <div class="company-form-container-title-wrapper">
                <div class="col-sm-12 px-3 company-form-box-title">List of Leavers from Provident Fund</div>
            </div>
            <div class="col-md-12 company-form-container-content-wrapper">
                <div v-if="custom_list.length>0">
                    <common-list :action_btn_text="action_btn_text"  :pageurl="this.$api_url"  :is_pf="is_n_pf"  is_action=0 :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
                </div>
                <div v-else>

                    <div v-if="show_loader" class="list-no-data">
                        <span class="d-block text-center">Looking for relevant data..</span>
                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    </div>
                    <div v-else class="list-no-data">
                        Looks like there is no employee to show.
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>

    <b-modal size="lg" class='pf-dereg-details-modal' id="bv-modal-process-settlement" hide-footer :title="'Provident Fund Particulars for '+curr_emp_name">
            <b-overlay :show="showoverlay" class='showoverlay_settle' rounded="sm">
                <div class="d-block">
                    <b-form>                    
                        <div class="clearfix">   
                            <div class="row clearfix">
                            <div class="col-md-12 float-left">    
                                <div class="card-body">
                                    <div class="employee-table-wrapper">
                                        
                                        <table class="employee-list-table dataTable table-overflow table-sticky">
                                    
                                        <thead>
                                        <tr class="table-head">
                                            <td class="text-center">
                                                Particulars
                                            </td>
                                            <td class="text-center">
                                                Balance (BDT)
                                            </td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Employer’s contribution to PF
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_salary_fund_employer)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Employee’s contribution to PF
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_salary_fund_employee)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Profit balance on employer’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_profit_fund_employer)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Profit balance on employee’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_profit_fund_employee)}}
                                            </td>
                                           
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Forfeiture balance on employer’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_forfeiture_fund_employer)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Forfeiture balance on employee’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_forfeiture_fund_employee)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Advance balance
                                            </td>
                                            <td class="text-right">
                                                ({{formatMoney(curr_emp_loan_total)}})
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Total
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_pf_total_adjusted)}}
                                            </td>
                                            
                                        </tr>
                                        </tbody>
                                        </table> 
                                        
                                    </div> 
                                </div>    

                               

                                 
                            </div>  
                          </div>                           
                        </div>
                    
                       
                    </b-form> 
                </div>
            </b-overlay>
    </b-modal>
</div>
</template>

<script>
    import myUpload from 'vue-image-crop-upload';
    import moment from 'moment';
    export default{
        
        mounted() {
            this.showoverlay = false;
        },
        props: ['flg','pageurl'],
        components: {
           'my-upload': myUpload
        },
        data(){            
            let sortOrders = {};
           
        
            return {
                action_btn_text:'Details',
                showoverlay:false,
                is_n_pf:1,
                is_action:0,
                show_loader : true,
                default_column:['name','email','employee_code'], /* Default Column List */
                appended_column:[
                    
                    { value: "pf_start", text: "PF Start Date",type: "date"},
                    { value: "pf_end", text: "PF End Date",type: "date"},
                    // { value: "pf_total", text: "PF Balance (BDT)",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "pf_total", text: "PF Balance (BDT)",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    
                    ],                   /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */
                list_key:1,
                custom_list:[],  /* Data List */
                tmp_custom_list:[],

                curr_emp_name: '',
                curr_emp_id: 0,
                curr_emp_pf_total: 0,
                curr_emp_loan_total: 0,
                curr_emp_pf_total_adjusted:0,


                curr_emp_salary_fund: 0,
                curr_emp_salary_fund_employer: 0,
                curr_emp_salary_fund_employee: 0,
                curr_emp_profit_fund: 0,
                curr_emp_profit_fund_employer: 0,
                curr_emp_profit_fund_employee: 0,
                curr_emp_forfeiture_fund: 0,
                curr_emp_forfeiture_fund_employer: 0,
                curr_emp_forfeiture_fund_employee: 0,

                curr_emp_settle_balance: 0,
                curr_emp_settle_balance_show: 0, 

            }
        },
        methods:{

            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            processSettlement: function(employee_id)
            {

                let currentObj = this;
                currentObj.showoverlay = true;
                axios.get(this.$api_url+'/pf/employee/data' , {
                    params: {
								employee_id: employee_id,
							}
    
                }).then(function(response){

                    var temp_data = response.data.employee_data;
                    var item = temp_data[employee_id];
                    this.curr_emp_pf_total =item.pf_total;
                    this.curr_emp_loan_total = item.loan_adjustable;
                    this.curr_emp_pf_total_adjusted = this.toMoney(this.curr_emp_pf_total) - this.curr_emp_loan_total;
                    this.curr_emp_salary_fund = item.salary_fund + item.migrated_pf_company_contribution + item.migrated_pf_employee_contribution - item.final_salary_contribution_company - item.final_salary_contribution_employee - item.partial_salary_contribution_employee - item.partial_salary_contribution_company;
                    this.curr_emp_salary_fund_employer = item.employer_unregistered_provident_fund + item.migrated_pf_company_contribution - item.final_salary_contribution_company - item.partial_salary_contribution_company;
                    this.curr_emp_salary_fund_employee = item.employee_unregistered_provident_fund + item.migrated_pf_employee_contribution - item.final_salary_contribution_employee - item.partial_salary_contribution_employee;
                    
                    this.curr_emp_profit_fund = item.profit_fund + item.migrated_pf_profit_employee_contribution + item.migrated_pf_profit_company_contribution - item.final_profit_contribution_employee - item.final_profit_contribution_company - item.partial_profit_contribution_employee - item.partial_profit_contribution_company;

                    this.curr_emp_profit_fund_employer = item.employee_profit_distrtibuted_fund_company + item.migrated_pf_profit_company_contribution - item.final_profit_contribution_company - item.partial_profit_contribution_company;

                    this.curr_emp_profit_fund_employee = item.employee_profit_distrtibuted_fund_employee + item.migrated_pf_profit_employee_contribution - item.final_profit_contribution_employee - item.partial_profit_contribution_employee;

                    this.curr_emp_forfeiture_fund = item.forfeiture_fund + item.migrated_pf_forfeiture_employee_contribution + item.migrated_pf_forfeiture_company_contribution - item.final_forfeiture_contribution_employee - item.final_forfeiture_contribution_company - item.partial_forfeiture_contribution_employee - item.partial_forfeiture_contribution_company;

                    this.curr_emp_forfeiture_fund_employer = item.employee_forfeiture_distrtibuted_fund_company + item.migrated_pf_forfeiture_company_contribution - item.final_forfeiture_contribution_company - item.partial_forfeiture_contribution_company;

                    this.curr_emp_forfeiture_fund_employee = item.employee_forfeiture_distrtibuted_fund_employee + item.migrated_pf_forfeiture_employee_contribution - item.final_forfeiture_contribution_employee  - item.partial_forfeiture_contribution_employee;

                    this.$bvModal.show('bv-modal-process-settlement');
                    currentObj.showoverlay = false;

                    }.bind(this)).catch(function (error){
                    currentObj.showoverlay = false;
                    console.log(error)
                });
                
                
            },
            listReturn: function(data)
            {
                
                if(data.trustee == 1)
                {
                    this.curr_emp_name = data.name;
                    this.processSettlement(data.employee_id);
                }

            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // }, 

            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
           
            getLeaverEmployeeListData: function()
            {
                let currentObj = this;
                if(!this.checkNet()) return false;

                this.show_loader = true;
                axios.get(this.$api_url+'/pf/leaver/list' , {

                }).then(function(response){

                    
                    
                    let leaver_custom = [];
                    /* Assingning the Options */ 

                    this.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */ 
                    this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    
                    if(this.tmp_custom_list.length > 0 )
                    {

                        
                        this.tmp_custom_list.forEach(element => {
                                if(element.employee_id > 0)
                                {
                                    element.pf_total = this.formatMoney(element.pf_total);
                                    let dop = []; 
                                    /*  If DropDown type one is First Choice */
                                    
                                    if(element.employee_pf_end_date != '0000-00-00' && element.employee_pf_end_date != '')
                                    {
                                        console.log('End Date');
                                        console.log(element.employee_pf_end_date);
                                        dop = dop.concat([{ label: 'Process Settlement' , value: 1 }]);
                                    }
                                    else
                                    {
                                        dop = dop.concat([{ label: 'End PF' , value: 3 }]);
                                    }
                                        
                                        //
                                    
                                    /* Action for all column **/

                                    element.actions = dop; 
                                    leaver_custom.push(element);
                                    if(element.last_payslip_date != null)
                                    {
                                        // if(element.leaving_date != '0000-00-00' && element.leaving_date != '')
                                        // {

                                        //     const last_payslip_date = element.last_payslip_date.split('-');
                                        //     var last_payslip_date_format = new Date(last_payslip_date[0],last_payslip_date[1]-1,1);
                                        //     const leaving_date = element.leaving_date.split('-');
                                        //     var leaving_date_format = new Date(leaving_date[0],leaving_date[1]-1,1);

                                        //     if(last_payslip_date_format.getTime() === leaving_date_format.getTime())
                                        //     {
                                                //leaver_custom.push(element);
                                                
                                            // }   
                                            
                                        //}

                                    }
                                    
                                }
                            }); 

                            // console.log(leaver_custom.length);
                        
                    }
                    else
                    {
                        this.blankmsg = "No employee found as leaver";
                    }
                    
                    this.custom_list = leaver_custom;
                    this.list_key = this.list_key + 1;
                    this.show_loader = false;
                }.bind(this)).catch(function (error){

                    console.log(error);
                    currentObj.serverError(error);
                    
                    });

            },
        },
        created: function(){
            if(!this.checkNet()) return false;
            
            this.getLeaverEmployeeListData();
        }
    }
</script>

<style>
.settlement_field_trz {
	margin-bottom: 0;
	width: 80%;
	margin: 0 0 0 auto;
}
.settlement_field_trz input {
	opacity: 1 !important;
	text-align: right;
}
.showoverlay_settle .b-overlay {
	height: 100%;
} 
</style>
